import axios from "axios";
import apiUrlOne from "../Config";

// Get all CMS contents
export const getAllCmsContents = async () => {
    try {
        const response = await axios.get(`${apiUrlOne}/cmscontent/getall-cmscontent`);
        return response.data; // { success: true, data: [...] }
    } catch (error) {
        console.error("Error fetching CMS contents:", error);
        throw error;
    }
};

// Get CMS content by type
export const getCmsContentByType = async (type) => {
    try {
        const response = await axios.get(`${apiUrlOne}/cmscontent/getcmscontent/${encodeURIComponent(type)}`);
        return response.data; // { success: true, data: { ... } }
    } catch (error) {
        console.error("Error fetching CMS content by type:", error);
        throw error;
    }
};

// Create CMS content
export const createCmsContent = async (formData) => {
    const response = await axios.post(
        `${apiUrlOne}/cmscontent/create-cmscontent`,
        formData,
        {
            headers: {
                "Content-Type": "application/json",
            },
        }
    );
    return response.data;
};

// Update CMS content
export const updateCmsContent = async (formData) => {
    const response = await axios.put(`${apiUrlOne}/cmscontent/update-cmscontent`, formData, {
        headers: { "Content-Type": "application/json" },
    });
    return response.data;
};

// Delete CMS content by type
export const deleteCmsContent = async (type) => {
    const response = await axios.delete(`${apiUrlOne}/cmscontent/delete-cmscontent/${encodeURIComponent(type)}`);
    return response.data;
};
